import PropTypes from 'prop-types';
import React from 'react';

import { Trash } from 'lucide-react';

import PopoverConfirmation from 'components/PopoverConfirmation';

export default function DeleteIconConfirmation({ handleClick }) {
  return <>
    <PopoverConfirmation
      placement='left'
      title="Are you sure you want to delete this entry?"
      yesAction={handleClick}
      trigger={<Trash size={16} />}
    />
  </>
}

DeleteIconConfirmation.propTypes = {
  id: PropTypes.string,
  handleClick: PropTypes.func,
};
